/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DdtUpdateDto } from '../../models/ddt-update-dto';
import { DdtItem } from '../../models/ddt-item';

export interface DdtControllerUpdate$Params {
  id: number;
      body: DdtUpdateDto
}

export function ddtControllerUpdate(http: HttpClient, rootUrl: string, params: DdtControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DdtItem;
}>> {
  const rb = new RequestBuilder(rootUrl, ddtControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: DdtItem;
      }>;
    })
  );
}

ddtControllerUpdate.PATH = '/ddt/{id}';
